import React, {useEffect, useRef, useState} from 'react';
import SearchBar from './widgets/SearchBar';
import ContactList from './widgets/ContactList';
import {useEyeconxStore} from '../../../../store/eyeconxStore';
import smsgatewayService from '../../../../services/smsgateway.service';
import {toast} from 'react-toastify';
import Conversation from './widgets/Conversation';
import Loading from "../../layout/Loading";


const SMSFeature = () => {
    const [selectedUser, setSelectedUser] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchCriteria, setSearchCriteria] = useState('firstName');
    //const [message, setMessage] = useState('');
    const [chat, setChat] = useState({});
    const [users, setUsers] = useState([])
    const [loading, setLoading] = useState(false)
    const clinicId = useEyeconxStore(state => state.user.clinicId)
    const clinicInfo = useEyeconxStore(state => state.clinicInfo)

    const [loadConversation, setLoadConversation] = useState(false)
    const isMounted = useRef(false); // ref to track if the component is mounted
    const [nextPage, setNextPage] = useState(0)
    const [isLastPage, setIsLastPage] = useState(false)
    const [conversationDetails, setConversationDetails] = useState([])
    const [conversationDetailsLoading, setConversationDetailsLoading] = useState(false)
    useEffect(() => {
        // console.log("Function called ")

        if (!isMounted.current) {
            isMounted.current = true;
            getUserList();
        }
    }, []);

    const getConversationDetails = () => {
        setConversationDetailsLoading(true)
        smsgatewayService.getConversationDetails(clinicId, selectedUser)
            .then(res => {
                setConversationDetails(res.data)
                // console.log("Conversation Details : ")
                // console.log(res.data)
                setConversationDetailsLoading(false)
            })
            .catch(err => {
                toast.error("Error getting Conversation Details");
                setConversationDetailsLoading(false)
            })
    }
    const getUserList = (pageNo = 0, pageSize = 30, searchString = "") => {
        console.log("Get User List")
        console.log("PageNo:" + pageNo + " PageSize: " + pageSize + " search String " + searchString)
        setLoading(true)
        smsgatewayService.getInbox(clinicId, searchCriteria, searchString, pageNo, pageSize)
            .then(res => {
                console.log(res.data)
                //setUsers(res.data)
                setUsers((prevUser) => [...prevUser, ...res.data.content])
                setNextPage(res.data.pageable.pageNumber + 1)
                setIsLastPage(res.data.last)
                setLoading(false)
            })
            .catch(err => {
                toast.error("Error getting Users");
            })
    }
    const handleConversation = (user, pageNo = 0, pageSize = 30) => {
        setLoadConversation(true)
        smsgatewayService.getConversation(clinicId, user, pageNo, pageSize)
            .then(res => {
                console.log(res.data)
                console.log("Sms Chat Data")
                setChat(res.data)
                setLoadConversation(false)
            })
            .catch(err => {
                toast.error("Error getting Conversation");
                setLoadConversation(false)
            })
    }
    const handleUserSelect = (user) => {
        handleConversation(user)
        setSelectedUser(user);

    };

    const handleSearchChange = (strSearch) => {
        // setSearchTerm(strSearch);
        setUsers([])
        getUserList(0, 30, strSearch)
        //getUserList()
        // setSearchTerm(e.target.value);
    };

    const handleSearchCriteriaChange = (e) => {
        setSearchCriteria(e.target.value);
    };

    const handleSendMessage = (message, isConfirmationRequired = false) => {
        if (message.trim() === '' || !selectedUser) return;
        //add this message to chat.content array

        const sendNewMessage = {
            "clinicId": clinicId,
            "business": clinicInfo.sms,
            "customer": chat[0].customer,
            "message": message,
            "isConfirmationRequired": isConfirmationRequired
        }

        smsgatewayService.sendMessage(clinicId, sendNewMessage)
            .then(res => {
                console.log(res.data)
                const newMessage = {
                    "business": clinicInfo.sms,
                    "customer": selectedUser,
                    "message": res.data.message,
                    "customerFirstName": chat[0].customerFirstName,
                    "customerLastName": chat[0].customerLastName,
                    "customerDob": chat[0].customerDob,
                    "messageType": "OUTGOING",
                    "status": "ACCEPTED",
                    "modifiedDate": getTodayDate(),
                    "modifiedTime": getCurrentTime()
                }

                //add to top of chat

                setChat(prevChat => [...prevChat, newMessage])
            })
            .catch(err => {
                toast.error("Error sending Message");
            })


        // setMessage('');
    };

    const getTodayDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    const getCurrentTime = () => {
        const now = new Date();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
    };

    const handleReset = () => {

        setSearchCriteria("firstName")
        setSearchTerm("")
        setUsers([])
        getUserList(0, 30, "")
    }
    const handleLoadMore = () => {
        console.log("NextPage" + nextPage)
        getUserList(nextPage, 5)
    }
    const handleRefresh = () => {
        setSelectedUser(null)
        setConversationDetails(null)
        setUsers([])
        getUserList(0, 30, "")
    }
    return (
        <div className="container">
            <div className="row mt-3" style={{height: "85vh"}}>
                <div className="col-md-4 card p-1 border-end shadow">
                    <div className="d-grid">
                        <button className='btn btn-light-success rounded btn-sm mb-3' onClick={handleRefresh}><i
                            className="bi bi-arrow-repeat fs-4"></i> Refresh Messages
                        </button>
                    </div>

                    <SearchBar
                        handleSearchChange={handleSearchChange}
                        searchCriteria={searchCriteria}
                        handleSearchCriteriaChange={handleSearchCriteriaChange}
                        searchTerm={searchTerm}
                        handleReset={handleReset}
                    />
                    {loading && loading ? <Loading/> :
                        <ContactList users={users} handleUserSelect={handleUserSelect} selectedUser={selectedUser}
                                     handleLoadMore={handleLoadMore} lastPage={isLastPage}/>
                    }
                </div>
                <div className="col-md-8 d-flex flex-column">

                    {selectedUser ? (
                        <>
                            {loadConversation && loadConversation ? <Loading/> : <>{chat &&
                                <Conversation smsData={chat} handleSendMessage={handleSendMessage}
                                              getConversationDetails={getConversationDetails}
                                              conversationDetails={conversationDetails}
                                              conversationDetailsLoading={conversationDetailsLoading}/>}</>}


                        </>
                    ) : (
                        <div className="d-flex justify-content-center align-items-center flex-grow-1">
                            <h4>Please select a user to view conversation</h4>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SMSFeature;
